import React, { useEffect, useState } from 'react'

import useExamInform from '@hooks/useExamInform'
import ScoreBoard from '@components/ScoreBoard/ScoreBoard'

const ScoreBoardContainer: React.FC = () => {
  const [countWrittenScore, setCountWrittenScore] = useState(0)
  const [countPracticalScore, setCountPracticalScore] = useState(0)
  const [isPass, setIsPass] = useState(false)

  const { getAnswerResultsByCurrentGroup, currentQuestionGroup } = useExamInform()

  useEffect(() => {
    const answerResult = getAnswerResultsByCurrentGroup()
    if (answerResult) {
      setIsPass(answerResult.passTest ?? false)
      setCountPracticalScore(answerResult.countPracticalCorrect ?? 0)
      setCountWrittenScore(answerResult.countWrittenCorrect ?? 0)
    }
  }, [getAnswerResultsByCurrentGroup])

  const scoreBoardProps = {
    countWrittenScore,
    countPracticalScore,
    isPass,
    isPublic: currentQuestionGroup?.type == 'public',
  }
  return <ScoreBoard {...scoreBoardProps} />
}

export default ScoreBoardContainer
